import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="device-list-form"
export default class extends Controller {
  static targets = ["imsiPairsSection", "imsiPairsContainer"]
  
  connect() {
    this.index = this.imsiPairsContainerTarget.children.length
  }

  toggleImsiPairs(event) {
    const status = event.target.value
    if (status === 'P') {
      this.imsiPairsSectionTarget.classList.remove('hidden')
    } else {
      this.imsiPairsSectionTarget.classList.add('hidden')
    }
  }

  addImsiPair(event) {
    event.preventDefault()
    
    const template = this.buildImsiPairTemplate()
    this.imsiPairsContainerTarget.insertAdjacentHTML('beforeend', template)
    this.index++
  }

  removeImsiPair(event) {
    event.preventDefault()
    const fieldContainer = event.target.closest('[data-nested-form-target="fieldContainer"]')
    
    // If it has a destroy checkbox (persisted record), mark for destruction
    const destroyCheckbox = fieldContainer.querySelector('input[type="checkbox"][name*="_destroy"]')
    if (destroyCheckbox) {
      destroyCheckbox.checked = true
      fieldContainer.style.display = 'none'
    } else {
      // For new records, just remove from DOM
      fieldContainer.remove()
    }
  }

  buildImsiPairTemplate() {
    const timestamp = new Date().getTime()
    
    return `
      <div class="bg-gray-50 border border-gray-200 rounded-lg p-5 relative group hover:border-gray-300 transition-colors" data-nested-form-target="fieldContainer">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div>
            <label class="block text-[14px] font-medium text-secondary-100 mb-2">IMSI Number</label>
            <input type="text" 
                   name="device_list[imei_imsi_pairs_attributes][${timestamp}][imsi]"
                   class="w-full px-4 py-2.5 border border-gray-300 rounded-md shadow-xs text-[14px] focus:outline-hidden focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                   placeholder="Enter 15 digit IMSI"
                   maxlength="15"
                   pattern="[0-9]{15}"
                   required>
            <p class="mt-1 text-[12px] text-gray-500">Exactly 15 digits</p>
          </div>

          <div class="md:col-span-2">
            <label class="block text-[14px] font-medium text-secondary-100 mb-2">Pair Description</label>
            <input type="text"
                   name="device_list[imei_imsi_pairs_attributes][${timestamp}][description]"
                   class="w-full px-4 py-2.5 border border-gray-300 rounded-md shadow-xs text-[14px] focus:outline-hidden focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                   placeholder="Optional description for this pairing"
                   required>
            <p class="mt-1 text-[12px] text-gray-500">Describe the purpose of this pairing</p>
          </div>
        </div>

        <!-- Remove button positioned absolutely -->
        <div class="absolute top-3 right-3">
          <button type="button" 
                  class="inline-flex items-center p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
                  data-action="click->device-list-form#removeImsiPair"
                  title="Remove this IMSI pair">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    `
  }
}
